export const getProfileEntryId = (profile) =>
  typeof profile === "string" ? profile : profile?._id;

export const getFirstProfileId = (collaborator) => {
  const profiles = collaborator?.profiles || [];
  return getProfileEntryId(profiles[0]) || collaborator?._id || null;
};

/** First profile (index 0) always maps to the collaborator record for reads/updates. */
export const isMainProfileId = (collaborator, profileId = null) => {
  if (!collaborator?._id) return false;

  const resolvedId =
    profileId ??
    collaborator?.currentProfile?._id ??
    collaborator?.currentProfile ??
    null;

  if (!resolvedId) return true;

  const firstProfileId = getFirstProfileId(collaborator);

  return (
    String(resolvedId) === String(collaborator._id) ||
    (firstProfileId && String(resolvedId) === String(firstProfileId))
  );
};

/** PATCH target: first profile -> /collaborators/{collaborator._id}, others -> /profiles/{id}. */
export const getActiveProfilePatchTarget = (collaborator, profileId = null) => {
  if (!collaborator?._id) return null;

  if (isMainProfileId(collaborator, profileId)) {
    return { type: "collaborator", id: collaborator._id };
  }

  const resolvedId =
    profileId ??
    collaborator?.currentProfile?._id ??
    collaborator?.currentProfile;

  if (!resolvedId) return null;

  return { type: "profile", id: resolvedId };
};

export const getProfilePicturePatchTarget = (collaborator) =>
  getActiveProfilePatchTarget(collaborator);

export const buildMainProfilePreview = (collaboratorData) => ({
  _id: collaboratorData._id,
  first_name: collaboratorData.first_name,
  last_name: collaboratorData.last_name,
  title: collaboratorData.title,
  company: collaboratorData.company,
  profile_picture: collaboratorData.profile_picture,
});

export const normalizePublicProfilesList = (collaboratorData) => {
  const profiles = collaboratorData?.profiles || [];
  if (profiles.length === 0) return [];

  const first = buildMainProfilePreview(collaboratorData);
  if (profiles.length === 1) return [first];

  const secondEntry = profiles[1];
  const second =
    typeof secondEntry === "object" && secondEntry !== null
      ? secondEntry
      : { _id: getProfileEntryId(secondEntry) };

  return [first, second];
};

export const withCollaboratorMeta = (raw, extra = {}) => ({
  ...raw,
  ...extra,
  _id: raw._id,
  collaborator_id: raw.collaborator_id,
  backoffice_id: raw?.backoffice_id,
  team_id: raw?.team_id,
});
